module.exports = __webpack_public_path__ + "assets/img/21_1111_big.ef66cef9.jpg";